import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, PendenciaPontoLinha } from '../../api.service';

export type LinhaPendenciaPonto = PendenciaPontoLinha;

@Injectable({ providedIn: 'root' })
export class ServicoPendenciaPonto {
  constructor(private readonly api: ApiService) {}

  filtroPadrao() {
    const hoje = new Date();
    const dataAtual = this.dataParaIsoLocal(hoje);
    return {
      dataInicial: dataAtual,
      dataFinal: dataAtual
    };
  }

  pesquisar(
    empregadorId: string,
    dataInicial: string,
    dataFinal: string,
    funcionarioSelecionado?: string,
    departamentoIds?: string[]
  ): Observable<LinhaPendenciaPonto[]> {
    return this.api.listarPendenciasPonto(empregadorId, dataInicial, dataFinal, funcionarioSelecionado || undefined, departamentoIds);
  }

  mensagemEmpregadorObrigatorio() {
    return 'Selecione um empregador para pesquisar pendencias.';
  }

  mensagemErroPesquisar() {
    return 'Erro ao pesquisar pendencias de ponto.';
  }

  baixarPendenciasPdf(empregadorId: string, dataInicial: string, dataFinal: string, funcionarioId?: string, departamentoIds?: string[]) {
    return this.api.baixarPendenciasPontoPdf(empregadorId, dataInicial, dataFinal, funcionarioId, departamentoIds);
  }

  abrirPdfEmNovaAba(blob: Blob, aba: Window) {
    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
    aba.location.href = url;
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  }

  mensagemPdfGerado() {
    return 'Relatorio de pendencias em PDF gerado.';
  }

  mensagemErroAbrirPdf() {
    return 'Nao foi possivel abrir o PDF em nova aba. Verifique o bloqueador de pop-ups do navegador.';
  }

  private dataParaIsoLocal(data: Date) {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }
}
